// extracted by mini-css-extract-plugin
export default {"title":"alamat-email-pembeli-properti_title__FSDhO","input-wrapper":"alamat-email-pembeli-properti_input-wrapper__LMfyD","info":"alamat-email-pembeli-properti_info__BRmdo"};